import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=1c89f8d8&"
import script from "./UserUpdate.vue?vue&type=script&lang=js&"
export * from "./UserUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports